// test1264
(1264 && 0);
